import { ReactNode } from 'react';
import { Button, Content, H2, Stack, Text } from '@kinesis/bungle';
import { Center } from '@/components/center';
import { KinesisLogo } from '@/components/kinesis-logo';

// The faces of the invitation landing screen: pending (accept/decline),
// already accepted, expired, not found, and "log in to continue". Mirrors
// the share-accept page's message card.
const InvitationMessage = (props: InvitationMessageProps) => {
  const { title, children, actions = [] } = props;
  return (
    <Content background='white' borderRadiusSize='large' width={304}>
      <Content padding='large' sizing='fill-container' paddingMode='equal'>
        <Stack space='medium'>
          <Center>
            <KinesisLogo />
          </Center>
          <Center>
            <H2>{title}</H2>
          </Center>
          <Text>{children}</Text>
          {actions.map((action) => (
            <Button
              key={action.label}
              display='block'
              variant={action.variant}
              loading={action.loading}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          ))}
        </Stack>
      </Content>
    </Content>
  );
};

export type InvitationMessageAction = {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  loading?: boolean;
};

export type InvitationMessageProps = {
  title: string;
  children?: ReactNode;
  actions?: InvitationMessageAction[];
};

export { InvitationMessage };
